import MembershipService from '@xo-union/sdk-membership';
import UnionHeaderNav from '@xo-union/tk-component-header-nav/remote';
import React from 'react';

interface Props {
  product: string | undefined;
}

const redirectUri = process.env.REACT_APP_DASHBOARD_REDIRECT || '/';
const client = new MembershipService();
const redirect = () => window.location.assign(redirectUri);
const handleLogout = () => client.logOut().then(redirect);

const HeaderNav = ({ product }: Props) => (
  <UnionHeaderNav
    data-testid="tk-header"
    loggedIn
    analyticsProps={{ product }}
    metadata={{ applicationName: product }}
    onClickLogOut={handleLogout}
    activeProduct="wedding-website"
  />
);

export default HeaderNav;
